import { render, staticRenderFns } from "./FeaturesComponent.vue?vue&type=template&id=5e789386&scoped=true&"
import script from "./FeaturesComponent.vue?vue&type=script&lang=js&"
export * from "./FeaturesComponent.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesComponent.vue?vue&type=style&index=0&id=5e789386&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e789386",
  null
  
)

export default component.exports